/**
 * System Services Module
 * Exports all system services and factory functions
 */
// Service exports (one per controller)
export * from './SystemService';
export * from './ApiRequestLogService';
export * from './QueryPerformanceLogService';
export * from './LogsService';
export * from './HealthService';
export * from './ServicesService';
export * from './RabbitMQManagementService';
export * from './RedisManagementService';
export * from './RabbitMQTestService';
export * from './RedisTestService';
export { VendorSystemSettingsService } from './VendorSystemSettingsService';
export { SystemRevenueService } from './SystemRevenueService';
// Service imports for factory
import { SystemService } from './SystemService';
import { ApiRequestLogService } from './ApiRequestLogService';
import { QueryPerformanceLogService } from './QueryPerformanceLogService';
import { LogsService } from './LogsService';
import { HealthService } from './HealthService';
import { ServicesService } from './ServicesService';
import { RabbitMQManagementService } from './RabbitMQManagementService';
import { RedisManagementService } from './RedisManagementService';
import { RabbitMQTestService } from './RabbitMQTestService';
import { RedisTestService } from './RedisTestService';
import { VendorSystemSettingsService } from './VendorSystemSettingsService';
import { SystemRevenueService } from './SystemRevenueService';
/**
 * Create all system services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all system service instances
 */
export function createSystemServices(http, config) {
    return {
        system: new SystemService(http, config),
        apiRequestLog: new ApiRequestLogService(http, config),
        queryPerformanceLog: new QueryPerformanceLogService(http, config),
        logs: new LogsService(http, config),
        health: new HealthService(http, config),
        services: new ServicesService(http, config),
        rabbitMQManagement: new RabbitMQManagementService(http, config),
        redisManagement: new RedisManagementService(http, config),
        rabbitMQTest: new RabbitMQTestService(http, config),
        redisTest: new RedisTestService(http, config),
        vendorSystemSettings: new VendorSystemSettingsService(http, config),
        systemRevenue: new SystemRevenueService(http, config),
    };
}
//# sourceMappingURL=index.js.map